export class TypeGuide {
    id: number;
    name: string;
    code: string;
}